import * as THREE from 'three';
import type { ComposerMount } from '../types';
import type { FXJSON } from './schema';

const TONE_MAPPING_VALUES = {
  NoTone: THREE.NoToneMapping,
  Linear: THREE.LinearToneMapping,
  Reinhard: THREE.ReinhardToneMapping,
  Cineon: THREE.CineonToneMapping,
  ACESFilmic: THREE.ACESFilmicToneMapping,
  AgX: THREE.AgXToneMapping,
  Neutral: THREE.NeutralToneMapping,
} as const satisfies Record<FXJSON['toneMapping'], THREE.WebGLRenderer['toneMapping']>;

export function applyMapFx(
  renderer: THREE.WebGLRenderer,
  composer: ComposerMount,
  fx: FXJSON | null | undefined,
): void {
  if (fx == null) return;
  renderer.toneMapping = TONE_MAPPING_VALUES[fx.toneMapping];
  renderer.toneMappingExposure = fx.toneMappingExposure;
  if (composer.bloom != null) {
    composer.bloom.strength = fx.bloomStrength;
    composer.bloom.radius = fx.bloomRadius;
    composer.bloom.threshold = fx.bloomThreshold;
  }
}
